<app-header title="SDS" subTitle=""></app-header>
<div class="main-container">
    <div class="header">
        <h1>
Application Users List        </h1>
<button pbutton (click)="navigateToNew()"class="new-button p-button-raised p-button-text" type="button"><i class="pi pi-user-plus"></i>   New</button>

<input type="text" pInputText class="form-control" placeholder="Search" [(ngModel)]="searchQuery" (ngModelChange)="onSearchInputChange($event)" />
</div>
<!-- <div class="header">
  <h1>Application Users List</h1>
  <button (click)="navigateToNew()" class="new-button p-button-outlined" type="button" icon="pi pi-plus">New</button>
  <div (mouseenter)="expandSearchBar()" (mouseleave)="collapseSearchBar()" class="search-container" [class.expanded]="isSearchExpanded">
      <input type="text" pInputText class="form-control" placeholder="Search" [(ngModel)]="searchQuery" (ngModelChange)="onSearchInputChange($event)" />
      <i class="pi pi-search"></i>
  </div>
</div> -->
    <div class="card">
        <p-table  [columns]="cols" [value]="this.userService.data" [paginator]="true" styleClass="p-datatable-lg" [rows]="8"
          [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords} items" class="custom-table" [(selection)]="selectedUsers" >
          <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.sortable ? col.field : null" [ngClass]="{'custom-header': col.field !== 'Actions', 'centered-header': col.field === 'Actions'}">
                    {{ col.header }}
                    <p-sortIcon *ngIf="col.sortable" [field]="col.field" class="custom-sort-icon"></p-sortIcon>

                  </th>
                <th class="custom-header">Actions</th> <!-- New column for actions -->
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" >
            <tr  class="row-separator" >
                
                <td *ngFor="let col of columns" [ngClass]="{'custom-cell': col.field === 'productName'}">
                  {{ rowData[col.field] }}
                </td>
                <!-- Actions column with edit and delete icons -->
                <td class="custom-cell">
                  <button pButton type="button" icon="pi pi-pencil" class="action-btn"  (click)="navigateToDetail(rowData)"></button>
                  <button pButton type="button" icon="pi pi-trash"class="action-btn-delete" (click)="deleteUser(rowData.username)"></button>
                </td>
              </tr>
          </ng-template>
        </p-table>
      </div>
  </div>
  <p-dialog header="Confirmation" [(visible)]="displayConfirmationDialog" id="dialogId"  [modal]="true" [draggable]="false" [closable]="true" [styleClass]="'confirmation-dialog'" appendTo="body">
    <p>
      Are you sure that you want to delete the selected record?
    </p>
    <p-footer>
        <button type="button" icon="pi pi-times" pButton (click)="goBack()" class=" p-button-raised p-button-success p-button-text">
            <span style="margin-left: 5px;">No</span>
          </button>
        <button type="button" icon="pi pi-check" pButton (click)="confirmDelete()" class=" p-button-raised p-button-danger p-button-text">
            <span style="margin-left: 5px;">Yes</span>
        </button>
    </p-footer>
  </p-dialog>